var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 black",staticStyle:{"overflow":"hidden"},attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"height":"100vh"},attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('the-ato-snackbar'),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }